import { gql } from '@apollo/client';

export default gql`
  mutation updateSalaryitem(
    $_id: String
    $basicSalary: Float
    $extraSalary: Float
    $bonos: Float
    $overtime: Float
    $deduction: Float
    $desc: String
  ) {
    updateSalaryitem(
      _id: $_id
      basicSalary: $basicSalary
      extraSalary: $extraSalary
      bonos: $bonos
      overtime: $overtime
      deduction: $deduction
      desc: $desc
    ) {
      ok
      message
      error
    }
  }
`;
